import { render, staticRenderFns } from "./EmergencyCard.vue?vue&type=template&id=3a8c6dfc&scoped=true"
import script from "./EmergencyCard.vue?vue&type=script&lang=js"
export * from "./EmergencyCard.vue?vue&type=script&lang=js"
import style0 from "./EmergencyCard.vue?vue&type=style&index=0&id=3a8c6dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8c6dfc",
  null
  
)

export default component.exports